import { httpRequest } from "../../http.ts";

export interface SegmentLinkItem {
  id: number;
  name: string;
}

/** A launch on this population (MPN-1675): its billing boundary and whether any of
 *  its audiences is live on a network. Live with no date = every conversion loads
 *  as a pre-convert and nothing bills until the date is set (MPN-1687). */
export interface SegmentLinkLaunch extends SegmentLinkItem {
  go_live_date: string | null;
  is_live: boolean;
}

export interface SegmentLinkJourneyPath {
  id: number;
  name: string;
  pricesheet_id: number;
  contract_id: number;
  contract_name: string | null;
}

export interface SegmentLinks {
  id: number;
  name: string;
  ingest_definitions: SegmentLinkItem[];
  /** This engagement's launches only. */
  launches: SegmentLinkLaunch[];
  /** Org-wide live launches on this segment (other engagements included). */
  launch_count_total: number;
  /** Scoped paths. null = caller lacks Contracts view; [] = none scoped. */
  journey_paths: SegmentLinkJourneyPath[] | null;
}

export interface SegmentLinksOrphans {
  ingest_definitions_without_segment: SegmentLinkItem[];
  /** Unset only — explicit "no population" (lookalike/DB-fed) launches are excluded. */
  launches_without_segment: SegmentLinkItem[];
}

/** Segment-centric link graph for one engagement (MPN-1483). */
export interface EngagementSegmentLinks {
  segments: SegmentLinks[];
  orphans: SegmentLinksOrphans;
}

export class CommandGetSegmentLinks {
  async run(engagementId: number): Promise<EngagementSegmentLinks> {
    const url = `${
      import.meta.env.VITE_API_PLATFORM_SERVICE_URL
    }api/v1/engagements/${engagementId}/segment-links/`;
    return httpRequest<EngagementSegmentLinks>(url, { method: "GET" });
  }
}
